
import { jsBridgeGetBtnPerPromise, jsBridgeGetMenuPerPromise } from 'platform-lib-app';
import { toRaw, createApp } from 'vue';
import { Toast } from 'vant';
const app = createApp();
app.use(Toast);

import router from '.';
import { isAppEnv } from 'platform-lib-app';
import { usePermission } from '@/store/modules/permission';
import { useUser } from '@/store/modules/user';
import { getSubjectInfo } from '@/utils/jsbridge/webEntrance';

export function setupRouterGuard (router) {
  if (isAppEnv) {
    getBtnPermsGuard(router);
    getMenuPermsGuard(router);
  }

  setSubjectInfo(router);
  routerGohome(router);
  routeErrorHandle();
}
const setSubjectInfo = (router) => {
  router.beforeEach(async(to, from, next) => {
    const shopMdCode = to.query?.shopMdCode;
    const userStore = useUser();
    if (userStore.subjectInfo) {
      const subjectInfo = await getSubjectInfo();
      userStore.subjectInfo = subjectInfo;
    }
    if (shopMdCode) {
      userStore.subjectInfo.subjectShop.mdCode = shopMdCode;
    }
    next();
  });
};

const routerGohome = (router) => {
  router.beforeEach((to, from, next) => {
    const permissionStores = usePermission();
    const toHomeName = permissionStores.toHome;
    if (toHomeName && to.name != toHomeName) {
      router.go(-1);
    } else {
      permissionStores.toHome = null;
    }
    next();
  });
};

/**
 * 按钮权限
 * @param {*} router
 */
function getBtnPermsGuard (router) {
  router.beforeEach(async (to, from) => {
    const permissionStore = usePermission();
    try {
      if (!permissionStore.btnPermissions) {
        const result = await jsBridgeGetBtnPerPromise();
        result && (permissionStore.btnPermissions = result);
      }
    } catch (error) { }

    return true;
  });
}

/**
 * 菜单权限
 * @param {*} params
 */
function getMenuPermsGuard (params) {
  router.beforeEach(async (to, from) => {
    const permissionStore = usePermission();
    try {
      // first route
      if (!permissionStore.menuPermissions && to.path != '/noPermissionsAnomalies') {
        const res = await jsBridgeGetMenuPerPromise();

        if (res && res.length > 0) {
          permissionStore.routerPermissions = res;
          const flattedArray = flatMenus(res);

          if (flattedArray.length > 0) {
            permissionStore.menuPermissions = flattedArray;
            mergeBtnPerms();
          }
        }

      }
    } catch (error) {
      if (error == 'no response') {
        // native not response menu permissions
        return {
          path: '/noPermissionsAnomalies'
        };

      } else {
        return true;
      }
    }
    return true;

  });
}



function routeErrorHandle () {
  router.onError((error, to, from) => {
    console.error('router.onError', error.message);

    const pattern = /Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS for/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
      // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
      location.reload();
    } else {
      Toast.fail({
        message: '跳转失败，请重试',
      });
    }
  });
}



// menus中的权限标识，合并到btnPermissions
function mergeBtnPerms () {
  const permissionStore = usePermission();
  const flattedArray = toRaw(permissionStore.menuPermissions);
  const btnArray = toRaw(permissionStore.btnPermissions);

  if (btnArray) {
    const btnPermsInMenus = flattedArray.reduce((prev, cur) => {
      if (cur.perms) {
        return prev.concat(cur.perms);
      }
    }, []);

    const mergedBtnPerms = Array.from(new Set([...btnPermsInMenus, ...btnArray]));
    permissionStore.btnPermissions = mergedBtnPerms;
  }
}

function flatMenus (permissions) {
  const flattedMenus = [];
  permissions.forEach(perm => {
    if (Array.isArray(perm.children) && perm.children.length > 0) {
      flattedMenus.push(...flatMenus(perm.children));
    } else {
      if (perm && perm.resourceType === 1) {
        // 菜单1 目录0
        flattedMenus.push(perm);
      }
    }
  });
  return flattedMenus;
}

